import { makeStyles } from '@material-ui/core/styles';
import { btMediumGrayColor, btNavyBlueColor } from '../../assets/jss/nextjs-material-kit-pro';

const formStyles = makeStyles((theme) => ({
  sectionTitle: {
    lineHeight: '50px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.00rem',
      fontWeight: 600,
      margin: '15px 0 5px 0',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.10rem',
      fontWeight: 600,
      margin: '25px 0 5px 0',
    },
  },
  paper: {
    padding: '10px',
  },
  reminder: {
    color: 'blue',
    fontSize: '1.05rem',
  },
  [theme.breakpoints.down('xs')]: {
    textField: {
      fontSize: '0.75rem',
    },
    root: {
      '& .MuiFormLabel-root': {
        fontSize: '0.75rem',
      },
    },
  },
  rowSpacer: {
    [theme.breakpoints.up('sm')]: {
      height: 30,
    },
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  rowSpacer50: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
    [theme.breakpoints.down('sm')]: {
      height: 50,
    },
  },
  textRowSpacer: {
    paddingRight: '10px',
    paddingTop: '10px',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '5px',
    },
  },
  textRowLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      minHeight: 30,
      paddingTop: 15,
      overflow: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 30,
      paddingTop: 10,
      overflow: 'auto',
    },
  },
  radioGroupLabel: {
    paddingTop: 7,
  },
  radioLabel: {
    fontSize: '0.85rem',
    fontWeight: 500,
    '& svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  subtleBold: {
    fontWeight: 500,
    color: btMediumGrayColor,
  },
  datepicker: {
    '& .MuiFilledInput-root': {
      background: 'rgb(255, 255, 255)',
    },
  },
  textAreaFont: {
    fontSize: '1.00rem',
    fontFamily: 'Source Sans Pro, Helvetica, Roboto, Arial, sans-serif',
    padding: 10,
  },
  textArea5RowSpacer: {
    [theme.breakpoints.down('sm')]: {
      minHeight: 115,
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 105,
    },
  },
  textArea10RowSpacer: {
    marginTop: '10px',
    [theme.breakpoints.down('sm')]: {
      minHeight: 215,
    },
    [theme.breakpoints.up('sm')]: {
      minHeight: 205,
    },
  },
  error: {
    color: '#FA0000',
    fontSize: '0.90rem',
    fontWeight: 600,
  },
  success: {
    color: '#00AA00',
    fontSize: '0.90rem',
    fontWeight: 600,
  },
  essayOptions: {
    fontSize: '0.90rem',
    fontWeight: 500,
    color: btNavyBlueColor,
  },
  buttonWidth: {
    width: 110,
  },
  floatingButton: {
    width: 110,
    position: 'absolute',
    right: 15,
    bottom: 15,
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  buttonSpacer: {
    height: 50,
    marginTop: 20,
  },
  dispositionNote: {
    fontSize: '1.05rem',
    border: '1px solid blue',
    padding: 15,
    backgroundColor: '#FFFAF0',
  },
  gradingSectionTitle: {
    fontSize: '1.125rem',
    fontWeight: 600,
    margin: '20px 0 5px 0',
  },
  gradeLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      minHeight: 30,
      paddingTop: 15,
      paddingRight: 5,
      overflow: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 30,
      paddingTop: 17,
      paddingRight: 5,
      overflow: 'auto',
    },
  },
  gpaSpacer: {
    paddingLeft: 5,
    [theme.breakpoints.down('md')]: {
      minHeight: 30,
      paddingTop: 15,
      paddingRight: 5,
      overflow: 'auto',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 30,
      paddingTop: 17,
      paddingRight: 5,
      overflow: 'auto',
    },
  },
  marginRight40: {
    marginRight: 40,
  },
  gpaNote: {
    fontSize: '0.80rem',
    fontWeight: 300,
  },
  labelSpacer: {
    padding: '10px 0 2px 0',
  },
  labelXLSpacer: {
    padding: '35px 0 0 0',
  },
  printableTableHeader: {
    padding: '10px 0 0 0',
    fontWeight: 600,
  },
  printableTableHeight: {
    padding: '5px 0 0 0',
  },
  statusRowSpace: {
    paddingTop: 15,
    height: '140px',
    overflow: 'auto',
    marginBottom: 20,
  },
}));

export default formStyles;
